import * as React from 'react';
import './App.css';
import Screen from './Calendar.js';

function App() {


	return(
		<>
			<Screen />
		</>
	);

}


export default App;
